import { hnaviCategoryPath, featurePostListPath } from '@paths';

const A: React.FC<{ href?: string; children: any }> = ({ children, href }) => (
  <a
    href={href}
    className='w-full bg-lightgray py-4 text-center font-bold text-top-primary hover:text-primary'
  >
    {children}
  </a>
);

export const HnaviLinksBlock: React.FC<{
  categoryName?: string | null;
  categoryCode?: string | null;
}> = ({ categoryName, categoryCode }) =>
  categoryName && categoryCode ? (
    <div className='flex flex-wrap gap-4 md:mb-16 md:flex-nowrap'>
      <A href={hnaviCategoryPath(categoryCode)}>
        {categoryName}の企業一覧はこちら
      </A>
      <A href={featurePostListPath(categoryCode)}>
        {categoryName}のおすすめ企業はこちら
      </A>
    </div>
  ) : null;
